import React from "react";
import { Boxes, MapPin, Warehouse } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { FieldLabel, RadioCard, SectionLabel } from "./FormPrimitives";

export const WAREHOUSE_OPTIONS = ["Yiwu", "Shenzhen", "Foshan", "Other"];

export const CargoPickupCard = ({ form, setField }) => (
  <Card className="border-zinc-200 shadow-sm">
    <div className="p-6 md:p-8">
      <SectionLabel hint="Optional">Cargo &amp; Pickup</SectionLabel>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="md:col-span-2">
          <FieldLabel htmlFor="commodity" icon={Boxes}>Commodity</FieldLabel>
          <Input
            id="commodity"
            data-testid="input-commodity"
            placeholder="e.g. Electronics, Apparel, Auto parts"
            value={form.commodity}
            onChange={(e) => setField("commodity", e.target.value)}
            className="h-11"
          />
        </div>
      </div>

      <div className="mt-5">
        <div className="text-xs font-semibold tracking-[0.12em] uppercase text-zinc-500 mb-2">
          Pickup From
        </div>
        <div className="grid grid-cols-2 gap-3">
          <RadioCard
            testid="radio-pickup-reef"
            checked={form.pickup === "reef_warehouse"}
            onClick={() => setField("pickup", "reef_warehouse")}
            icon={Warehouse}
            label="Reef China Warehouse"
            sublabel="Pick from our hub"
          />
          <RadioCard
            testid="radio-pickup-supplier"
            checked={form.pickup === "supplier_location"}
            onClick={() => {
              setField("pickup", "supplier_location");
              setField("warehouse_location", "");
            }}
            icon={MapPin}
            label="Supplier Location"
            sublabel="Direct from supplier"
          />
        </div>
      </div>

      {form.pickup === "reef_warehouse" && (
        <div className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <FieldLabel htmlFor="warehouse_location">Warehouse Location</FieldLabel>
            <Select
              value={WAREHOUSE_OPTIONS.includes(form.warehouse_location) ? form.warehouse_location : (form.warehouse_location ? "Other" : "")}
              onValueChange={(v) => setField("warehouse_location", v === "Other" ? "" : v)}
            >
              <SelectTrigger className="h-11" data-testid="select-warehouse-trigger">
                <SelectValue placeholder="Select warehouse (optional)" />
              </SelectTrigger>
              <SelectContent>
                {WAREHOUSE_OPTIONS.map((w) => (
                  <SelectItem key={w} value={w} data-testid={`warehouse-${w}`}>{w}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          {(!WAREHOUSE_OPTIONS.includes(form.warehouse_location) || form.warehouse_location === "") && form.pickup === "reef_warehouse" && (
            <div>
              <FieldLabel htmlFor="warehouse_other">Other Address</FieldLabel>
              <Input
                id="warehouse_other"
                data-testid="input-warehouse-other"
                placeholder="Specify warehouse address"
                value={WAREHOUSE_OPTIONS.includes(form.warehouse_location) ? "" : form.warehouse_location}
                onChange={(e) => setField("warehouse_location", e.target.value)}
                className="h-11"
              />
            </div>
          )}
        </div>
      )}
    </div>
  </Card>
);
